import axios from 'axios';
import Slider from "react-slick";
import { CRangeSlider } from '@coreui/react-pro'
import Select, { components } from 'react-select';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ImageViewer } from 'react-iv-viewer';
import "react-iv-viewer/dist/react-iv-viewer.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Tooltip } from 'react-tooltip';
import { TreeSelect }  from 'antd';
import { Watermark }  from 'antd';
import { AreaChart } from '@mantine/charts';
import { BarChart } from '@mantine/charts';
import { BubbleChart } from '@mantine/charts';
import { MantineProvider, Title, createTheme } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import './index.css'
import { React, useState, useEffect, useRef } from "react";
import { Vitessce } from 'vitessce';
import process from 'process';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// Populate default Vitessce config per project
const defaultConfigs = {}
// Populate default sections per project
const defaultSections = {}

const featureIntensityColormaps = [
    {value: 'plasma', label: 'plasma'},
    {value: 'viridis', label: 'viridis'},
    {value: 'jet', label: 'jet'}
];
// Used in top features in section plot
const numTopFeatures = 5;

// Theme for titles of Mantine charts
const theme = createTheme({
  headings: {
    textWrap: 'wrap',
  },
});

// Project contains a list of projects that
// are meant to be served from the server that
// this code is deployed on
const module = await import("./default_configs/projects.json", {
    with: { type: 'json' },
})
const projects = module.default['projects'];
const sections = module.default['default_sections'];


for (var i = 0; i < projects.length; i++) {
   let proj = projects[i];
   defaultSections[proj] = sections[i];
   defaultConfigs[proj] = await import("./default_configs/" + proj);
}

// Add a non-react library to DOM
function addJsLibrary(urlOfTheLibrary) {
    let el = document.querySelector("#three_d_zarr");
    if (!el) {
        const script = document.createElement("script");
        script.src = urlOfTheLibrary;
        script.async = true;
        script.id = "three_d_zarr";
        document.head.appendChild(script);
    }
}

function forceConvertToASCII(str) {
    if (str !== undefined) {
        // eslint-disable-next-line no-control-regex
        return str.replace(/[^\x00-\x7F]/g, "");
    }
    return str;
}

export default function Home() {
    const entityTypeSeparator = "@";
    // project (and optional entity type and entity value) are passed as URL parameters - see App.js
    let project = forceConvertToASCII(useParams().project);
    let entityType = forceConvertToASCII(useParams().entity_type);
    let entityValue = forceConvertToASCII(useParams().entity_value);
    // Note: for historical reasons this is called patient but essentially it is a method for selecting
    // subsets of sections to be shown in a single WebAtlas2.0 instance
    let patient = forceConvertToASCII(useParams().patient);
    let section = forceConvertToASCII(useParams().section);
    if (!section) {
        // Setting section to the default one has the result of snRNASeq UMAP being loaded
        // on first load of the project page, e.g. https://www.gbmspace.org/webatlas2/GBM)
        section = defaultSections[project];
    }
    // This option indicates that the portal should display two Vitessce instances side-by-side
    let mv = forceConvertToASCII(useParams().mv);

    // Retrieve default Vitessce config for project
    let defaultConfig;
    if (projects.includes(project)) {
        defaultConfig = defaultConfigs[project];
    }

    // Highlight colours for Vitessce
    const highlightColours = [
        [0, 0, 255], [0, 255, 0], [1, 215, 95], [192, 0, 6], [167, 67, 244], [255, 246, 69],
        [0, 98, 113], [1, 81, 231], [255, 245, 225], [162, 255, 205], [32, 93, 67], [82, 80, 104],
        [46, 111, 0], [214, 228, 255], [166, 255, 124], [137, 53, 85], [121, 255, 101], [0, 100, 99],
        [255, 170, 78], [196, 0, 56], [0, 117, 69], [129, 26, 175], [255, 254, 206], [1, 86, 193],
        [250, 255, 187], [255, 252, 166], [129, 49, 131], [2, 167, 100], [88, 255, 167], [0, 98, 15],
        [255, 95, 133], [1, 193, 225], [150, 44, 63], [255, 208, 227], [123, 66, 68], [72, 190, 0],
        [255, 182, 167], [2, 126, 249], [255, 235, 166], [234, 0, 166], [26, 94, 56], [255, 124, 235],
        [239, 255, 134], [73, 200, 255], [134, 62, 6], [157, 255, 221], [157, 37, 19], [1, 135, 105],
        [179, 94, 0], [1, 170, 151], [255, 135, 118], [84, 238, 255], [133, 61, 49], [190, 139, 255],
        [97, 81, 41], [255, 83, 200], [142, 134, 0], [255, 137, 211], [156, 175, 0], [109, 77, 22],
        [151, 255, 183], [255, 185, 126]
    ];

    // Project description - populated via the API call
    const [description, setDescription] = useState("");
    const dontRerenderIdx = -1;
    const apiRootURI = process.env.REACT_APP_ROOT_URI ?? "/api/";
    const apiStaticRootURI = apiRootURI + "static/";
    const [scRNASeqDataURL, setSCRNASeqDataURL] = useState("");
    // labUrl and infoUrl are driven by project - hence will be fetched via the API
    const [labUrl, setLabUrl] = useState(null);
    const [infoUrl, setInfoUrl] = useState(null);
    const [selectedSlide, setSelectedSlide] = useState(0);
    const [slider, setSlider] = useState(null);
    const [sliderData, setSliderData] = useState([]);
    const [intensityPlotData, setIntensityPlotData] = useState([]);
    const [topFeaturesPlotData, setTopFeaturesPlotData] = useState([])
    // Ditto - for the two Vitessce panels layout, for the non-selected ('the other') panel
    const [otherTopFeaturesPlotData, setOtherTopFeaturesPlotData] = useState([])
    const [RNASeqPlotData, setRNASeqPlotData] = useState([])
    const [RNASeqPlotTitle, setRNASeqPlotTitle] = useState("")
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState("");
    // selectedSection is used to find the index of that section
    // in case selectedEntity had been selected (in which case
    // the order of thumbnails is highest expression first (i.e. not
    // the default one in section_annotations.tsv)
    const [selectedSection, setSelectedSection] = useState("");
    // topGenesSection is used to know which section to display bar chart of top genes for
    // e.g. when that section is selected as a result of user selecting a gene
    const [topGenesSection, setTopGenesSection] = useState("");
    const [otherTopGenesSection, setOtherTopGenesSection] = useState("");
    // All continuous entity type labels for this project
    const [allContinuousEntityTypes, setAllContinuousEntityTypes] = useState([]);
    // All categorical entity type labels for this project (that apply to Visium slides
    // and thus are offered in the dropdowns outside of Vitessce)
    const [allCategoricalEntityTypes, setAllCategoricalEntityTypes] = useState([]);
    // All categorical entity types that apply to RNASeq only (thus are offered within
    // Vitessce only)
    const [allRNASeqOnlyCategoricalEntityTypes, setAllRNASeqOnlyCategoricalEntityTypes] = useState([]);
    // All continuous entity types that apply to Visium only (thus are not to be updated
    // in RNASeq UMAP)
    const [allImagingOnlyCategoricalEntityTypes, setAllImagingOnlyCategoricalEntityTypes] = useState([]);
    // The s3 root url for the project
    const [s3Url, setS3Url] = useState([]);
    // Continuous entity type options - for selection in the dropdowns
    const [continuousEntityTypes, setContinuousEntityTypes] = useState([]);
    // Categorical entity type options - for selection in the dropdowns
    const [categoricalEntityTypes, setCategoricalEntityTypes] = useState([]);
    // Selected continuous variable entity type
    const [selectedEntityType, setSelectedEntityType] = useState("gene");
    // Selected hierarchical (categorical) variable entity type
    const [selectedCategoricalEntityType, setSelectedCategoricalEntityType] = useState("");
    // Stores entity (feature or anatomical region, cell type or state) selected in a
    // dropdown outside of Vitessce - that needs to be overlaid on top of all thumbnails
    // and highlighted in Vitessce image // e.g. gene@COL3A1 or anatomical_region@Spleen
    const [selectedEntity, setSelectedEntity] = useState("");
    // filterFeature and filterCategoricalEntity are used for highlighting
    // a feature within a certain hierarchical entity (e.g. anatomical region) only
    const [filterCategoricalEntity, setFilterCategoricalEntity] = useState("");
    const [filterFeature, setFilterFeature] = useState("");
    // Variable controlling OffCanvas visibility (it is where e.g.
    // the selected gene in a the selected anatomical region is highlighted)
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    // Feature intensity colour legend setting - for both Vitessce and thumbnails
    const [featureValueColormap, setFeatureValueColormap] = useState("plasma");
    // Feature intensity colour range setting - for both Vitessce Spatial component and thumbnails
    // Note: this range allows the user for restricting the colour range to a
    // narrower range of intensities - in order to increase the contrast of
    // intensities shown. For example, for intensity range of 16-1000 and
    // featureValueColormapRangeSpatial = [0,1] the leftmost colour in featureValueColormap
    // will correspond to intensity of 16 and the rightmost to 1000. However, for
    // featureValueColormapRangeSpatial = [0.25,0.75] the leftmost colour in featureValueColormap
    // will correspond to all intensities on or below 4 (= 0.25 * 16) and the rightmost
    // colour - to 750 (= 0.75 * 1000) and above.
    const [featureValueColormapRangeSpatial, setFeatureValueColormapRangeSpatial] = useState([0, 0.25]);
    // Ditto - but for RNASeq UMAP
    const [featureValueColormapRangeUMAP, setFeatureValueColormapRangeUMAP] = useState([0, 0.05]);
    // waterMark is used to indicate that a given project contains just test data
    const [watermark, setWatermark] = useState("");
    // SVG ReactComponent for the project
    const [SVG, setSVG] = useState("");
    // URL of 3D image (in zarr format) for the current project
    const [threeDZarrUrl, setThreeDZarrUrl] = useState("");
    // labelReplacements is used for storing project-specific label replacements for Vitessce panels
    const [labelReplacements, setLabelReplacements] = useState({});
    // If two Vitessce panels are shown side-by-side, rightSpatialPanelInFocus == false
    // indicates that the left panel is in focus, and vice-versa.
    const [rightSpatialPanelInFocus, setRightSpatialPanelInFocus] = useState(false);
    // otherPanelImgSliderIdx is used to store the slide index for the Vitessce panel
    // that is not in focus (a.k.a. the other panel)
    const [otherPanelImgSliderIdx, setOtherPanelImgSliderIdx] = useState(0);
    const handleOffCanvasClose = () => setShowOffCanvas(false);
    // By default, show Spatial Layers component in Vitessce
    const [hideSpatialLayers, setHideSpatialLayers] = useState(true)
    // By default, don't show 3D image (even if available for the project)
    const [show3DImage, setShow3DImage] = useState(false)
    // No Scatterplot and two Vitessce instances shown side by side
    const [twoVitessceInstances] = useState(mv ? true: false);
    // This bootstrap icon is shown inside the 'Toggle Spatial Layers' button
    const [eyeIcon, setEyeIcon] = useState("eye-slash");
    // This bootstrap icon is shown inside the 'Show 3D image' buttons
    const [threeDeyeIcon, setThreeDeyeIcon] = useState("eye-slash");
    // Default config for Vitessce
    let json;
    if (projects.includes(project)) {
        json = reconfigureJSON(project, defaultConfig, selectedEntity, hideSpatialLayers);
    }
    // Vitessce config for the single Vitessce app, or
    // the left Vitessce app - in the case two Vitessce apps are shown side by side
    const [selectedConfig, setSelectedConfig] = useState(json);
    // Vitessce config for the right Vitessce app -
    // in the case two Vitessce apps are shown side by side
    const [selectedConfig1, setSelectedConfig1] = useState(json);
    // Options available for selection in the features dropdown
    const [features, setFeatures] = useState([]);
    // Set-up specific to entity type dropdown - start
    const groupedOptions = [
        { label : 'Features', options : continuousEntityTypes },
        { label : 'Categorical Variables', options : categoricalEntityTypes },
    ];
    const groupStyles = {
      border: `2px dotted '#5243AA'`,
      color: 'white',
      background: '#5243AA',
      padding: '5px 0px',
      display: 'flex',
    };
    const GroupHeading = (props) => (
      <div style={groupStyles}>
        <components.GroupHeading {...props} />
      </div>
    );
    // Set-up specific to entity type dropdown - end

    // Options available for selection in the hierarchical variable dropdown
    const [categoricalEntityValues, setCategoricalEntityValues] = useState([]);
    // The index of the thumbnail to be scrolled to - either by direct user selection or
    // indirectly - when the user selects a feature from the dropdown outside of Vitessce
    // N.B. -1 value prevents double rendering on initial load (see: onReInit() below)
    const [scrollToThumbnailIndex, setScrollToThumbnailIndex] = useState(dontRerenderIdx);
    // The index of the thumbnail to be highlighted -
    // needs to be handled in a different render cycle to scrollToThumbnailIndex
    const [highlightThumbnailIndex, setHighlightThumbnailIndex] = useState(dontRerenderIdx);
    const [entityType2ObsCol, setEntityType2ObsCol] = useState({});
    const [categoricalEntityType2Children, setCategoricalEntityType2Children]  = useState({});
    const [entityType2State, setEntityType2State] = useState({});

    // This is used for removing the current feature selection
    // if either a different feature type or hierarchical entity
    // has been selected
    const featureRef = useRef("feature_selection");
    const defaultNumOfThumbnailsToShow = 5;

    // If pinSelectedSlide checkbox is ticked, the App shows intensity in the current slide/thumbnail;
    // otherwise thumbnails are sorted by maximum intensity first and the leftmost thumbnail (that with the highest
    // intensity) is highlighted/selected.
    const [pinSelectedSlide, setPinSelectedSlide] = useState("checked");

    // In two-Vitessce view the user may wish to compare visually spatial intensity of two different entities - each in its
    // own (left ot right) panel. This variable allows the user to highlight the selected entity in the panel that is
    // currently in focus.
    const [highlightInPanelInFocusOnly, setHighlightInPanelInFocusOnly] = useState(false);

    // Ignore entityType and entityValue if the user has selected an entity (selectedEntity)
    if (entityType && entityType in entityType2State && entityValue && !selectedEntity) {
        entityValue = entityType + entityTypeSeparator + entityValue;
    } else {
        entityValue = "";
    }

    // Ignore patient (passed as part of GET request) if the user has selected patient in the UI
    if (selectedPatient) {
        patient = "";
    }


    // Slider settings
    // C.f. https://react-slick.neostack.com/docs/api/
    const settings = {
        onReInit: () => {
            // Replace the default Vitessce panel labels with project-specific ones
            replaceTitles();
            if (entityValue) {
                // Reflect in the app entityType and entityValue (passed in GET request)
                let entitySelection = entityValue.split("@")[1];
                handleEntityTypeSelection(entityType);
                handleEntitySelection( entitySelection, entityType);
            } else if (patient) {
                 // Reflect in the app patient (passed in GET request)
                 handlePatientSelection(patient);
            } else if (section) {
                 // Reflect in the app section name (passed in GET request)
                 if (selectedSection === "") {
                    // This should happen on first page load only
                    fetchThumbnailIndex(sliderData, section, selectedEntity, selectedPatient, pinSelectedSlide);
                    setSelectedSection(section);
                 }
            }

            setSelectedSlide(slider?.innerSlider.state.currentSlide);
            if (scrollToThumbnailIndex > dontRerenderIdx && sliderData.length > 0) {
                const scrollToIdx = Math.max(scrollToThumbnailIndex - defaultNumOfThumbnailsToShow + 1, 0);
                // Move to the thumbnail to scrollToIdx
                // N.B. We scroll to scrollToIdx and not to scrollToThumbnailIndex to make scroll back arrow work correctly -
                // scrollToIdx needs to be the index of the leftmost visible thumbnail (and not the thumbnail we're
                // auto-selecting, unless they are the same thumbnail of course - in which case the slickGoTo is a no-op)
                slider?.slickGoTo(scrollToIdx);
                fetchConfigs(hideSpatialLayers, scrollToThumbnailIndex, otherPanelImgSliderIdx);
                // Prevent slider?.slickGoTo after this event from this point - in the case the user
                // starts using the arrows to navigate around the slider
                setHighlightThumbnailIndex(scrollToThumbnailIndex);
                setScrollToThumbnailIndex(dontRerenderIdx);
            } else if (highlightThumbnailIndex > dontRerenderIdx) {
                if (sliderData[highlightThumbnailIndex] !== undefined && 'title' in sliderData[highlightThumbnailIndex]) {
                    fetchTopFeaturesInSection(project, selectedEntity, sliderData[highlightThumbnailIndex]['title'], false);
                }
                if (twoVitessceInstances) {
                    if (sliderData[highlightThumbnailIndex] !== undefined && 'title' in sliderData[highlightThumbnailIndex]) {
                        fetchTopFeaturesInSection(project, selectedEntity, sliderData[otherPanelImgSliderIdx]['title'], true);
                    }
                }
                highlightThumbnail("#th" + highlightThumbnailIndex);
                if (sliderData[highlightThumbnailIndex] !== undefined && 'title' in sliderData[highlightThumbnailIndex]) {
                    highlightSectionInSVG(sliderData[highlightThumbnailIndex]['title']);
                }
           }
        },
        lazyLoad: true,
        focusOnSelect: false,
        // Note that navigation via dots serves only to jump to distant thumbnails in the slider, but does not in itself select
        // the image in Vitessce. For that, the user needs to actually click on a given thumbnail image.
        dots: true,
        slidesToShow: defaultNumOfThumbnailsToShow,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        vertical: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
        ]
      };

    useEffect(() => {
        if (projects.includes(project)) {
            fetchAllEntityTypes(project, "categorical", entityType);
            fetchAllEntityTypes(project, "continuous", entityType);
            fetchRNASeqOnlyEntityTypes(project);
            fetchImagingOnlyEntityTypes(project);
            fetchS3Url(project);
            fetchPatientData(project);
            // Overlay selectedFeature data on top of all the thumbnails in the slider
            fetchSliderData(project, selectedEntity, selectedPatient,
                            featureValueColormap, featureValueColormapRangeSpatial, selectedSection, pinSelectedSlide);
            fetchIntensityPlotData(project, selectedEntity, selectedPatient);
            fetchDescription(project);
            fetchSCRNASeqDataURL(project);
            fetchLabUrl(project);
            fetchInfoUrl(project);
            fetchWatermark(project);
            fetchSVG(project);
            fetch3DZarrUrl(project);
            fetchLabelReplacements(project);
            // Retrieve obs col names for each hierarchical entity (e.g. anatomical region) or entity
            // that is continuous in Visium anndata, but categorical in scRNASeq anndata
            fetchDataObsCols(project);
        }
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, []);


   function getEntityType(entity) {
        if (entity) {
            return entity.split(entityTypeSeparator)[0];
        }
        return "";
   }

   function onConfigChangeCallback(config) {
        // DEBUG console.log(config);
   }

   function onConfigChangeCallback1(config) {
        // DEBUG console.log(config);
   }

   function getEntity(entity) {
        if (entity) {
            return entity.split(entityTypeSeparator)[1];
        }
        return "";
   }

   function highlightThumbnail(thumbnailIdx) {
        // Reflect the thumbnail at index: thumbnailIdx selection for the user
        let el = document.querySelector(".th-selected");
        if (el) {
            el.className = 'th-unselected';
        }
        let selectedThumbnailEl = document.querySelector(thumbnailIdx);
        if (selectedThumbnailEl) {
            selectedThumbnailEl.className = 'th-selected';
        }
   }

   function replaceTitles() {
        let els = document.querySelectorAll(".vit-itwgso-titleLeft");
        Object.keys(els).forEach(idx => {
            const label = els[idx].innerText;
            if (labelReplacements[label] !== undefined) {
                 els[idx].innerText = labelReplacements[label] + (selectedEntity && highlightInPanelInFocusOnly ?
                    " : " + selectedEntity.split(entityTypeSeparator)[1] : "");
            }
        });
   }

   function fetchThumbnailIndex(thumbnails, selSection, selEntity, selPatient, pinSelectedSlide) {
       if (thumbnails.length > 0) {
            if (selEntity === "" || pinSelectedSlide === "checked") {
               let idx = 0;
               for (let i = 0; i < thumbnails.length; i++) {
                    let section = thumbnails[i];
                    if (section['title'] && selSection && section['title'] === selSection) {
                        idx = i;
                        break;
                    }
                }
                setScrollToThumbnailIndex(idx);
            } else if (selEntity && pinSelectedSlide === "") {
                // thumbnails returned for a selEntity search are always
                // sorted by the highest intensity first - and we always
                // highlight the left-most thumbnail.
                setScrollToThumbnailIndex(0);
            }
       } else if (selSection && selSection.length > 0) {
           // If for whatever reason thumbnails have not been populated,
           // we can find out the index of a given section from the API
           const apiURL = apiRootURI + "get_thumbnail_index/" + project + "?section=" + selSection + "&patient=" + selPatient;
           axios
              .get(apiURL)
              .then((response) => {
                  const idx = response.data;
                  setScrollToThumbnailIndex(idx);
              });
       }
   }

   // Extract all children of each hierarchical entity value (e.g. anatomical region) - needed for highlighting
   // of hierarchical entity values in Vitessce
   function fetchChildren(tree, ret) {
        const val = tree['title'];
        if (ret[val] === undefined) {
            ret[val] = [];
        }

        if (tree['children'] !== undefined) {
            for (let i in tree['children']) {
                const child = tree['children'][i];
                ret[val] = ret[val].concat(fetchChildren(child, ret));
            }
        }
        return [...ret[val], val];
   }

   function get_json(hierarchy) {
        let ret = [];
        Object.keys(hierarchy).forEach(item =>
        {
            let d = {};
            d['value'] = item;
            d['title'] = item;
            let children = get_json(hierarchy[item]);
            if (children) {
                d['children'] = children;
            }
            ret.push(d);
        });
        return ret;
   }

   function fetchHierarchicalData(project, entityType) {
        axios
          .get(apiRootURI  + "hierarchical_tree_data/" + project + "?data_key=" + entityType)
          .then((response) => {
            let tsvContentArr = response.data.split("\n");
            // first convert tsvContentArr to a hierarchy
            let hierarchy = {};
            let subHierarchy = hierarchy;
            tsvContentArr.forEach((row, index) =>
                {
                    if (index > 0) {
                        // index > 0 - skip header
                        row.split("\t").forEach((item, col) =>
                        {
                            if (item) {
                                if (subHierarchy[item] === undefined) {
                                    subHierarchy[item] = {}
                                }
                                // Go down 1 level - ready for the next value (a child of item)
                                subHierarchy = subHierarchy[item]
                            }
                        });
                        subHierarchy = hierarchy;
                    }
                }
            );
            if (Object.keys(hierarchy).length > 0) {
                // The above test to check if entityType is available for this project
                // Now convert hierarchy to json
                let json = get_json(hierarchy);
                // Now fetch children of each item in the hierarchy
                let children = {};
                for (let j in json) {
                     const item = json[j];
                     fetchChildren(item, children);
                }

                categoricalEntityType2Children[entityType] = children;
                setCategoricalEntityType2Children(categoricalEntityType2Children);
                entityType2State[entityType] = json;
                setEntityType2State(entityType2State);
                if (entityType === "anatomical_region" || entityType === "annotation") {
                      // Set the default hierarchical entity type,
                      // and the corresponding data in the
                      // hierarchical entity dropdown
                      setCategoricalEntityValues(json);
                      setSelectedCategoricalEntityType(entityType);
                }
                // Add entityType to the hierarchical entity type dropdown
                addEntityType(entityType, categoricalEntityTypes, "categorical");
            }
        });
   }

   function fetchDescription(project) {
        axios
          .get(apiRootURI + "description/" + project)
          .then((response) => {
              setDescription(response.data);
              document.title = description + " Portal";
          });
   }

   function fetchAllEntityTypes(project, continuousOrCategorical, entityType) {
        axios
          .get(apiRootURI + continuousOrCategorical + "_entity_types/" + project)
          .then((response) => {
              const entityTypes = response.data.split(",");
              if (continuousOrCategorical === "categorical") {
                for (let entityType of entityTypes) {
                    fetchHierarchicalData(project, entityType);
                }
                setAllCategoricalEntityTypes(entityTypes);
              } else {
                for (let et of entityTypes) {
                    let overrideDefault = false;
                    if (et === entityType) {
                        overrideDefault = true;
                    }
                    fetchContinuousEntityData(project, et, overrideDefault);
                }
                setAllContinuousEntityTypes(entityTypes);
              }
          });
   }

   function fetchRNASeqOnlyEntityTypes(project) {
        axios
          .get(apiRootURI + "project2scrnaseq_only_entities/" + project)
          .then((response) => {
              setAllRNASeqOnlyCategoricalEntityTypes(response.data);
          });
   }

   function fetchImagingOnlyEntityTypes(project) {
        axios
          .get(apiRootURI + "project2imaging_only_entities/" + project)
          .then((response) => {
              setAllImagingOnlyCategoricalEntityTypes(response.data);
          });
   }


   function fetchS3Url(project) {
        axios
          .get(apiRootURI + "project2s3_url/" + project)
          .then((response) => {
              setS3Url(response.data);
          });
   }

   function fetchSCRNASeqDataURL(project) {
        axios
          .get(apiRootURI + "scrnaseq_url/" + project)
          .then((response) => {
              setSCRNASeqDataURL(response.data);
          });
   }

   function fetchLabUrl(project) {
        axios
          .get(apiRootURI + "lab_url/" + project)
          .then((response) => {
              setLabUrl(response.data);
          });
   }

   function fetchInfoUrl(project) {
        axios
          .get(apiRootURI + "info_url/" + project)
          .then((response) => {
              setInfoUrl(response.data);
          });
   }

   function fetchWatermark(project) {
        axios
          .get(apiRootURI + "watermark/" + project)
          .then((response) => {
              setWatermark(response.data);
          });
   }

   function fetchSVG(project) {
        axios
          .get(apiRootURI + "svg/" + project)
          .then((response) => {
              if (response.data !== "") {
                  const importSVG = async () => {
                        const module = await import('./default_configs/svg/' + response.data);
                        setSVG(module.default);
                  }
                  importSVG();
              }
          });
   }

   function fetch3DZarrUrl(project) {
        axios
          .get(apiRootURI + "3d_zarr_url/" + project)
          .then((response) => {
              if (response.data !== "") {
                  setThreeDZarrUrl(response.data);
                  /* Call the function to add a JS library needed for displaying the 3D zarr */
                  addJsLibrary("https://cdn.jsdelivr.net/npm/itk-vtk-viewer@14.43.0/dist/itkVtkViewer.min.js")
              }
          });
   }

   function fetchLabelReplacements(project) {
        axios
          .get(apiRootURI + "label_replacements/" + project)
          .then((response) => {
              setLabelReplacements(response.data);
          });
   }

   function fetchPatientData(project) {
        axios
          .get(apiRootURI + "annotations/" + project + "/patient")
          .then((response) => {
              const results = [];
              // Store patients in the results array
              Object.keys(response.data).forEach((value) => {
                  results.push({
                      value: value,
                      label: value
                  });
              });
              // Update the patients state
              if (results.length > 0) {
                  setPatients([
                    {value: '', label: 'Select..'},
                    ...results
                  ])
              }
          });
   }

   function fetchDataObsCols(project) {
        axios
          .get(apiRootURI + "data_obs_cols/" + project)
          .then((response) => {
              setEntityType2ObsCol(response.data);
          });
   }

   function fetchTopFeaturesInSection(project, selEntity, selSection, other) {
       if (selEntity && selSection !== (other === true ? otherTopGenesSection : topGenesSection)) {
           const entityType = getEntityType(selEntity);
           let plotData = [];
           axios
              .get(apiRootURI + "top_features/" + project + "?entity_type=" + entityType + "&section=" + selSection)
              .then((response) => {
                     const max = numTopFeatures < response.data.length ? numTopFeatures : response.data.length;
                     for (let i = 0; i < max; i++) {
                        let d = {};
                        const tuple = response.data[i];
                        const maxIntensityInSection = tuple[1];
                        d['Feature'] = tuple[0];
                        d['Max. intensity'] = maxIntensityInSection;
                        plotData.push(d);
                    }
                    if (other === false) {
                        setTopFeaturesPlotData(plotData);
                    } else {
                        setOtherTopFeaturesPlotData(plotData);
                    }
              });
           if (other === false) {
                setTopGenesSection(selSection);
           } else {
                setOtherTopGenesSection(selSection);
           }
      }
   }

   function fetchRNASeqExpressions(project, selEntity) {
       if (selEntity) {
           const entity = getEntity(selEntity);
           const entityType = getEntityType(selEntity);
           let plotData = [];
           axios
              .get(apiRootURI + "scrnaseq_expressions/" + project + "/" + entityType + "/" + entity)
              .then((response) => {
                     for (let i = 0; i < response.data.length; i++) {
                        let d = {};
                        const tuple = response.data[i];
                        d['annotation'] = tuple[0];
                        d['index'] = 1;
                        d['expression'] = tuple[1];
                        plotData.push(d);
                    }
                    setRNASeqPlotData(plotData);
              });
      }
   }

   function fetchRNAPlotTitle(project) {
           axios
              .get(apiRootURI + "scrnaseq_plot_title/" + project)
              .then((response) => {
                     setRNASeqPlotTitle(response.data);
              });
   }

   function fetchIntensityPlotData(project, selEntity, selPatient) {
       const entity = getEntity(selEntity);
       const entityType = getEntityType(selEntity);
       let plotData = [];
       axios
          .get(apiRootURI + "list/" + project + "?entity_type=" + entityType + "&entity=" + entity + "&patient=" + selPatient)
          .then((response) => {
                 for (let i = 0; i < response.data.length; i++) {
                    const tuple = response.data[i];
                    const title = tuple[0];
                    let d = {};
                    d['Section'] = title;
                    const maxIntensityInSection = tuple[4];
                    const avgIntensityInSection = tuple[5];
                    d['Max. intensity'] = maxIntensityInSection;
                    d['Avg. intensity'] = avgIntensityInSection;
                    plotData.push(d);
                }
                setIntensityPlotData(plotData);
          });
   }

   function fetchSliderData(project, selEntity, selPatient, featureValueColormap, featureValueColormapRangeSpatial,
                             selSection, pinSelectedSlide) {
       const entity = getEntity(selEntity);
       const entityType = getEntityType(selEntity);
       let thumbnails = [];
       axios
          .get(apiRootURI + "list/" + project + "?entity_type=" + entityType + "&entity=" + entity + "&patient=" + selPatient)
          .then((response) => {
                let cnt = 0;
                for (let i = 0; i < response.data.length; i++) {
                    const tuple = response.data[i];
                    const title = tuple[0];
                    const description = tuple[1];
                    const img_name = tuple[2];
                    let slide = {};
                    slide['id'] = i;
                    slide['tag_id'] = "th" + cnt;
                    slide['img_name'] = img_name;
                    slide['title'] = title;
                    // When the user searches for a feature, the thumbnails are re-ordered by max. intensity first -
                    // the following ensures that that the section in the 'other' panel is found correctly in the
                    // re-ordered list of thumbnails
                    if (otherTopGenesSection !== "") {
                        if (title === otherTopGenesSection) {
                            setOtherPanelImgSliderIdx(i);
                        }
                    }
                    slide['description'] = description;
                    slide['alt'] = "image " + title;
                    slide['src'] = apiRootURI + "image/" + project + "/" + img_name +"?entityType="+entityType+"&entity="+entity+
                                   "&feature_value_colormap="+ featureValueColormap + "&feature_value_colormap_range="+featureValueColormapRangeSpatial
                    thumbnails.push(slide);
                    cnt++;
                }

                // Because populating thumbnails dynamically in react-slick is buggy (even 'infinite: true' claimed
                // on https://stackoverflow.com/questions/24889858/slick-slider-slickgoto-method-breaking-the-carousel as
                // as fix introduces its own host of slider problems), the only solution I found was to always bump up
                // (with 'blank' thumbnails) the number of thumbnails to defaultNumOfThumbnailsToShow - see below.
                let size = thumbnails.length;
                while (size < defaultNumOfThumbnailsToShow) {
                    let slide = {};
                    let prev_idx;
                    if (size > 0) {
                        prev_idx = thumbnails[size-1]['id'];
                    } else {
                        prev_idx = 0;
                    }
                    slide['id'] = prev_idx + 1;
                    slide['tag_id'] = "th" + slide['id'];
                    slide['img_name'] = "";
                    slide['title'] = "";
                    slide['description'] = "";
                    slide['alt'] = "";
                    slide['src'] = apiStaticRootURI + "blank_thumbnail.jpg";
                    thumbnails.push(slide);
                    size += 1;
                }

                setSliderData(thumbnails);
                fetchThumbnailIndex(thumbnails, selSection, selEntity, selPatient, pinSelectedSlide);
          });
   }

    function getDisplayName(entityType, pluralise) {
        var arr = entityType.replaceAll("_", " ").replace(/\b\w/g, l => l.toUpperCase()).split(" ");
        var ret = "";
        for (const [index, name] of arr.entries()) {
            if (ret.length > 0) {
                ret += " ";
            }
            ret += name;
            if (index === 1 && pluralise && !ret.endsWith("i")) {
                // "cell type lvl7" becomes "cell types lvl7" but "gene" becomes "genes"
                // ret.endsWith("i") is patch for not pluralising terms such as 'nuclei'
                ret += "s";
            }
        }
        if (arr.length === 1 && pluralise) {
            ret += "s";
        }
        return ret;
    }

    function isOfType(entityType, entityTypes) {
        var found = false;
        entityTypes.forEach((elem) => {
            if (elem['value'] === entityType) {
                found = true;
            }
        });
        return found;
    }

    // Add entityType to the hierarchical entity type dropdown
    function addEntityType(entityType, entityTypes, continuousOrCategorical) {
        if (!isOfType(entityType, entityTypes)) {
            const newFT = {
                  value: entityType,
                  label: getDisplayName(entityType, true),
            };
            entityTypes.push(newFT);
            if (continuousOrCategorical === "categorical") {
                setCategoricalEntityTypes(entityTypes);
            } else {
                setContinuousEntityTypes(entityTypes);
            }
        }
    }

    function fetchContinuousEntityData(project, entityType, overrideDefault) {
        axios
          .get(apiRootURI + "all_entities/" + project + "/" + entityType)
          .then((response) => {
              const results = []
              // Store entities in the results array
              response.data.all_entities.forEach((value) => {
                results.push({
                  value: value,
                  label: value,
                });
              });
              if (results.length > 0) {
                  const entities = [
                    {value: '', label: 'Select ' + getDisplayName(entityType, false)},
                    ...results
                  ]
                  entityType2State[entityType] = entities;
                  setEntityType2State(entityType2State);

                  // Update the entities state
                  if (entityType === "gene") {
                       // Since "gene" is the default entity type,
                       // populate the features dropdown with gene data
                       if (!overrideDefault) {
                            setFeatures(entities);
                       }
                  }
                  if (overrideDefault) {
                       setFeatures(entities);
                  }
                  addEntityType(entityType, continuousEntityTypes, "continuous");
              }
          });
    }

    function fetchConfigs(newVal, idx, otherPanelImgSliderIdx) {
        let img_name, other_img_name;
        if (rightSpatialPanelInFocus) {
            other_img_name = sliderData[idx]['img_name'];
            img_name = sliderData[otherPanelImgSliderIdx]['img_name'];
        } else {
            img_name = sliderData[idx]['img_name'];
            other_img_name = sliderData[otherPanelImgSliderIdx]['img_name'];
        }
           if (highlightInPanelInFocusOnly) {
              if (rightSpatialPanelInFocus) {
                  fetchConfig(project, other_img_name, selectedEntity, newVal, true);
              } else {
                  fetchConfig(project, img_name, selectedEntity, newVal, false);
              }
          } else {
              // Note: rightSpatialPanelInFocus=false => img_name (idx) and other_img_name (otherPanelImgSliderIdx)
              // This sets config corresponding to img_name for the LHS Vitessce instance
              fetchConfig(project, img_name, selectedEntity, newVal, false);
              // Note: rightSpatialPanelInFocus=true => img_name (otherPanelImgSliderIdx) and other_img_name (idx)
              // This sets config corresponding to other_img_name for the RHS Vitessce instance
              fetchConfig(project, other_img_name, selectedEntity, newVal, true);
          }
    }

    function handleHideSpatialLayers() {
        const newVal = !hideSpatialLayers;
        let idx = 0;
        if (scrollToThumbnailIndex > dontRerenderIdx) {
            idx = scrollToThumbnailIndex;
        } else if (highlightThumbnailIndex > dontRerenderIdx) {
            idx = highlightThumbnailIndex;
        }
        fetchConfigs(newVal, idx, otherPanelImgSliderIdx);
        if (newVal) {
            setEyeIcon("eye-slash");
        } else {
            setEyeIcon("eye");
        }
        setHideSpatialLayers(newVal);
    }

    function handlePatientSelectionEvent( e ) {
         const patientSelection = e.value;
         handlePatientSelection(patientSelection);
    }

    function handleColormapSelectionEvent( e ) {
         const colormapSelection = e.value;
         if (colormapSelection !== featureValueColormap ) {
            if (selectedEntity) {
                fetchSliderData(project, selectedEntity, selectedPatient,
                                colormapSelection, featureValueColormapRangeSpatial, selectedSection, pinSelectedSlide);
            }
            setFeatureValueColormap(colormapSelection);
         }
    }

    function handleColormapRangeSpatialSelectionEvent(e) {
        if (e[0] !== featureValueColormapRangeSpatial[0] || e[1] !== featureValueColormapRangeSpatial[1]) {
            if (selectedEntity) {
                fetchSliderData(project, selectedEntity, selectedPatient,
                                featureValueColormap, e, selectedSection, pinSelectedSlide);
            }
            setFeatureValueColormapRangeSpatial(e);
        }
    }

    function handleColormapRangeUMAPSelectionEvent(e) {
        if (e[0] !== featureValueColormapRangeUMAP[0] || e[1] !== featureValueColormapRangeUMAP[1]) {
            if (selectedEntity) {
                // Note: Even though we're not passing e to fetchSliderData, it has an effectt of refreshing Vitessce which
                // is what we're after.
                fetchSliderData(project, selectedEntity, selectedPatient,
                                featureValueColormap, featureValueColormapRangeSpatial, selectedSection, pinSelectedSlide);
            }
            setFeatureValueColormapRangeUMAP(e);
        }
    }

    function handlePatientSelection(patientSelection) {
        if (patientSelection !== selectedPatient) {
            fetchSliderData(project, selectedEntity, patientSelection,
                            featureValueColormap, featureValueColormapRangeSpatial, selectedSection, pinSelectedSlide);
            setSelectedPatient(patientSelection);
         }
    }

    // Handle feature type or categorical variable type selection event
    function handleEntityTypeSelectionEvent( e ) {
         const entityTypeSelection = e.value;
         handleEntityTypeSelection(entityTypeSelection);
    }

    function handleEntityTypeSelection(entityTypeSelection) {
         if (isContinuous(entityTypeSelection)) {
             if (entityTypeSelection !== selectedEntityType) {
                featureRef.current.clearValue();
                setSelectedEntityType(entityTypeSelection);
                setFeatures(entityType2State[entityTypeSelection]);
                // DEBUG console.log(project, entityTypeSelection);
             }
         } else if (isCategorical(entityTypeSelection)) {
             if (entityTypeSelection !== selectedCategoricalEntityType) {
                setSelectedCategoricalEntityType(entityTypeSelection);
                setCategoricalEntityValues(entityType2State[entityTypeSelection]);
                // DEBUG console.log(project, entityTypeSelection);
             }
         }
    }

    // Handle entity type selection event
    function handleEntitySelectionEvent(e, entityType) {
      let entitySelection;
      if (e) {
          if (isCategorical(entityType)) {
             entitySelection = e;
          } else {
             entitySelection = e.value;
          }
          handleEntitySelection( entitySelection, entityType );
      } else {
         // NB. e is null when the user selects an anatomical region (AR) and as a result
         // we clear the current selection in any of the feature
         // selection dropdowns via ref.current.clearValue()
         // - in that case we don't do anything else here
      }
    }

    // This is used when the user selects a feature in the dropdown outside of Vitessce
    function handleEntitySelection( entitySelection, entityType ) {
      const entity = getEntity(selectedEntity);
      if (entitySelection !== "" && entitySelection !== entity) {
          if (isCategorical(entityType)) {
              setFilterCategoricalEntity(entitySelection)
          } else {
              setFilterFeature(entitySelection);
          }
          const selEntity = entityType + entityTypeSeparator + entitySelection;
          setSelectedEntity(selEntity);
          fetchSliderData(project, selEntity, selectedPatient,
                          featureValueColormap, featureValueColormapRangeSpatial, selectedSection, pinSelectedSlide);
          fetchIntensityPlotData(project, selEntity, selectedPatient);
          fetchRNASeqExpressions(project, selEntity);
          fetchRNAPlotTitle(project);
          if (isCategorical(entityType)) {
             featureRef.current.clearValue();
          }
      }
    }

    function handleSpatialPanelFocusSwitch(e) {
        setRightSpatialPanelInFocus(e.target.checked);

        let idx = 0;
        if (highlightThumbnailIndex > dontRerenderIdx && highlightThumbnailIndex !== otherPanelImgSliderIdx) {
            idx = highlightThumbnailIndex;
        }
        setScrollToThumbnailIndex(otherPanelImgSliderIdx);
        setOtherPanelImgSliderIdx(idx);
    }

    // Add scRNA-seq content to spatial config
    function addSCRNASeq(project, json) {
        if (scRNASeqDataURL) {
            const scRNASeqDataId = extractSCRNASeqDataId(scRNASeqDataURL);
            if (scRNASeqDataId) {
                // First clone json into ret
                const ret = JSON.parse(JSON.stringify(json));
                let ds = { "uid" : scRNASeqDataId, "name" : scRNASeqDataId};
                const file = {}
                file["fileType"] = "anndata.zarr"
                file["url"] = scRNASeqDataURL;
                const options = {}
                options["obsEmbedding"] = [ { "path": "obsm/X_umap", "embeddingType": "X_UMAP", "dims": [0, 1] } ];
                options["obsSets"] = [];
                allRNASeqOnlyCategoricalEntityTypes.forEach(tuple => {
                    let name = tuple[0];
                    let obs_col = tuple[1];
                    options["obsSets"].push(
                      {
                        "name": name,
                        "path": "obs/" + obs_col
                      });
                });
                options["obsFeatureMatrix"] = { "path": "X" };
                file["options"] = options;
                ds["files"] = [ file ];
                ret["datasets"].push(ds);
                ret['coordinationSpace']['dataset']['B'] = scRNASeqDataId;
                return ret;
            } else {
                return json;
            }
        }
        return json;
    }

    function reconfigureJSON(project, json, selEntity, selHideSpatialLayers) {
        let ret = JSON.parse(JSON.stringify(json));
        let fl_idx = -1;
        let obs_sets_idx = -1;
        let scatterplot_idx = -1;
        let ly = ret['layout'];
        if (ly === undefined) {
            ly = [];
        }
        for (var i = 0; i < ly.length; i++) {
            const map = ly[i];
            if (map['component'] === 'layerController') {
                if (selHideSpatialLayers) {
                    // Spatial layers hidden
                    map['x'] = 13;
                    map['y'] = 13;
                    map['w'] = 0;
                    map['h'] = 0;
                } else {
                    map['x'] = 0;
                    map['y'] = 0;
                    map['h'] = 12;
                    if (twoVitessceInstances) {
                        // We need more space within app for the layer controller -
                        // so that the layer controller doesn't look squashed when
                        // two Vitessce apps are shown side-by-side
                        map['w'] = 6;
                    } else {
                        map['w'] = 3;
                    }
                }
            } else if (map['component'] === 'featureList') {
                fl_idx = i;
                if (selEntity) {
                    map['coordinationScopes']['featureSelection'] = 'A';
                    map['coordinationScopes']['featureSelection'] = 'B';
                }
            } else if (map['component'] === 'spatial') {
                if (twoVitessceInstances) {
                    if (selHideSpatialLayers) {
                        // Spatial layers hidden
                        map['x'] = 0;
                        map['w'] = 12;
                    } else {
                        map['x'] = 6;
                        map['w'] = 6;
                    }
                } else {
                    // One Vitessce app shown
                    map['x'] = 6;
                    map['w'] = 6;
                }
                if (selEntity) {
                    map['coordinationScopes']['featureSelection'] = 'A';
                    map['coordinationScopes']['obsSetSelection'] = 'A';
                    map['coordinationScopes']['featureValueColormap'] = 'A';
                    map['coordinationScopes']['featureValueColormapRange'] = 'A';
                }
            } else if (map['component'] === 'scatterplot') {
                if (twoVitessceInstances) {
                    // Scatterplot to be removed when two Vitessce apps are shown
                    scatterplot_idx = i;
                } else {
                    if (selHideSpatialLayers) {
                        // Spatial layers hidden
                        map['x'] = 0;
                        map['w'] = 6;
                    } else {
                        map['x'] = 3;
                        map['w'] = 3;
                    }
                    map['h'] = 12;
                    const entityType = getEntityType(selEntity);
                    let datasetVal = 'A';
                    if (scRNASeqDataURL) {
                        datasetVal = 'B';
                    }
                    if (!allImagingOnlyCategoricalEntityTypes.includes(entityType)) {
                        // In WEMB all feature types in Visium are also present in RNASeq data (and thus shown
                        // in UMAP), whereas in GBM only genes are shared between the two (thus other continuous entities
                        // such as cell states or niches should not be shown in UMAP).
                        map['coordinationScopes']['featureSelection'] = datasetVal;
                        map['coordinationScopes']['featureValueColormap'] = datasetVal;
                        map['coordinationScopes']['featureValueColormapRange'] = datasetVal;
                        if (selEntity) {
                            map['coordinationScopes']['obsSetSelection'] = datasetVal;
                        }
                    }
                    map['coordinationScopes']['dataset'] = datasetVal;

                }
            } else if (map['component'] === 'obsSets') {
                obs_sets_idx = i;
// Omer made a call to just hide this component. For now we hide it for all projects, but if it transpires it is needed
// for some projects and not others, I will make it hiding it configurable. Note that hiding 'obsSets' is a part of
// a larger layout re-shuffle (RNASeq UMAP on the right and Spatial on the left), hence making it configurable would need
// to affect the re-shuffle also. See other changes as prt of this commit.
//                const entityType = getEntityType(selEntity);
//                if (selEntity && isCategorical(entityType)) {
//                    // NB. In WEMB obsSets (categorical entity: ROI) selection is shown in Visium label only,
//                    // and when the user selects e.g. brain, all recursive anatomical hierarchy children of brain
//                    // are shown in Visium, and the following statement also ensures that obsSets selection allows
//                    // the user to switch brain parts on and off in Visium.
//                    // N.B. This code does currently not apply to GBM because we don't offer the user any categorical
//                    // entity dropdowns - in GBM obsSets selection is visualised in snRNASeq only (not Visium - hence no
//                    // dropdowns)
//                    map['coordinationScopes']['obsSetSelection'] = 'A';
//                }
//                map['x'] = 9;
            }
        }
        if (fl_idx !== -1) {
            // Remove 'featureList' component from Vitessce config
            ly.splice(fl_idx, 1);
        }
        if (obs_sets_idx !== -1) {
            // Remove 'obsSets' component from Vitessce config
            ly.splice(obs_sets_idx, 1);
        }
        if (scatterplot_idx !== -1) {
            // Remove 'scatterplot' component from Vitessce config
            ly.splice(scatterplot_idx, 1);
        }

        //
        /* On Mark Keller's advice, (re-)setting the UID property at the root of the config
           to a new (unique) value forces Vitessce to refresh its config cache. This workaround
           prevents the getTile() error when swapping certain configs in the same Vitessce instance.
         */
        ret['uid'] = new Date().getTime().toString();
        ret['coordinationSpace']['featureValueColormap'] = { 'A' : featureValueColormap, 'B' : featureValueColormap };
        ret['coordinationSpace']['featureValueColormapRange'] = { 'A' : featureValueColormapRangeSpatial, 'B' : featureValueColormapRangeUMAP };
        return ret;
    }

    function extractSCRNASeqDataId(scRNASeqDataURL) {
        let scRNASeqDataId = undefined;
        if (scRNASeqDataURL) {
            const arr = scRNASeqDataURL.match(/^.*\/(.*)-anndata\.zarr$/);
            if (arr) {
                scRNASeqDataId = arr[1];
            } else {
                console.log("WARNING: scRNASeqDataId not found within: " + scRNASeqDataURL);
            }
        }
        return scRNASeqDataId;
    }

    function isCategorical(entityType) {
        return allCategoricalEntityTypes.includes(entityType);
    }

    function isContinuous(entityType) {
        return allContinuousEntityTypes.includes(entityType);
    }

    function addEntityToJSON(json, selEntity) {
        const scRNASeqDataId = extractSCRNASeqDataId(scRNASeqDataURL);
        // First clone json into ret
        const ret = JSON.parse(JSON.stringify(json));
        if (!selEntity) {
            return ret;
        }
        const entity = getEntity(selEntity);
        const entityType = getEntityType(selEntity);
        if (!isCategorical(entityType)) {
            const selFeatureList = [];
            if (entity && entity.length > 0) {
                selFeatureList.push(entity);
                const cs = ret['coordinationSpace'];
                let coordinationScopes = { 'featureSelection': 'B'  };
                cs['featureSelection'] = { 'A' : selFeatureList, 'B' : selFeatureList};
                if (scRNASeqDataId) {
                    cs['dataset']['B'] = scRNASeqDataId;
                }
                // We create 'featureList' component in Vitessce (only so that we can set 'featureSelection': 'A', 'featureSelection': 'B'
                // within its 'coordinationScopes'- necessary for highlighting feature expression within Vitessce's image
                // and scRNA-seq scatterplot) but keep it hidden from the user
                ret['layout'].push(
                    { 'component' : 'featureList',
                    'coordinationScopes' : coordinationScopes,
                    'h': 0, 'w': 0, 'x': 13, 'y': 13}
                );
            }
        } else {
            // isCategorical(entityType)
            const title = getDisplayName(entityType, true);
            const obsColName = entityType2ObsCol[entityType];
            const children = categoricalEntityType2Children[entityType];
            const dss = ret['datasets']
            for (let i in dss) {
                let ds = dss[i];
                for (let j in ds['files']) {
                    let dsf = ds['files'][j];
                    if (dsf['fileType'] === 'anndata.zarr'
                        && 'options' in dsf
                        && 'obsSets' in dsf['options']) {
                        dsf['options']['obsSets'] = [
                            {
                                'name' : title,
                                'path' : "obs/" + obsColName
                            }
                        ]
                    }
                }
            }
            const cs = ret['coordinationSpace'];
            cs['obsSetSelection'] = {};
            cs['obsSetColor'] = {};
            ['A', 'B'].forEach(ds => {
                cs['obsSetSelection'][ds] = [];
                cs['obsSetColor'][ds] = [];
                // Highlight entity and all of its recursive children
                if (children[entity] !== undefined) {
                    const entities = [...children[entity], entity];
                    for (let i in entities) {
                        const entity = entities[i];
                        cs['obsSetSelection'][ds].push
                        (
                            [ title, entity ]
                        );
                        const len = highlightColours.length;
                        // Below: modulo in Javascript
                        const colorPos = ((i % len) + len) % len;
                        // TODO: The below appears to be overriden by Vitessce with its own range of colours
                        // and I don't know how to stop that from happening.
                        cs['obsSetColor'][ds].push
                        (
                            { 'path'  : [ title, entity ], 'color' : highlightColours[colorPos] }
                        );
                    }
                }
            });
        }
        return ret;
    }

    function fetchConfig(project, img_name, selEntity, selHideSpatialLayers, rightSpatialPanelInFocus) {
        if (img_name && s3Url) {
            const sectionLabel = img_name.replace(/\.jpeg$/,"-config.json");
            let url = s3Url;
            if (!s3Url.endsWith("/")) {
                url = s3Url + "/";
            }
            axios
              .get(url + sectionLabel)
              .then((response) => {
                    // Remove featureSelection component from Vitessce and make the spatial component larger
                    let json = reconfigureJSON(project, response.data, selEntity, selHideSpatialLayers);
                    json = addSCRNASeq(project, json);
                    // If the user had selected an entity, show it within the image in Vitessce
                    json = addEntityToJSON(json, selEntity);
                    if (rightSpatialPanelInFocus) {
                        setSelectedConfig1(json);
                    } else {
                        // This subsumes the case of !twoVitessceInstances
                        setSelectedConfig(json);
                    }
              });
          }
    }

    function handleHighlightInPanelInFocusOnlyChange() {
        setHighlightInPanelInFocusOnly(!highlightInPanelInFocusOnly);
    }

    function handlePinSelectedSlideChange() {
        // Handle user change to the pinSelectedSlide check box
        if (pinSelectedSlide === "checked") {
            setPinSelectedSlide("");
            // Scroll to/highlight the thumbnail corresponding to selectedEntity (if selected) -
            // as it may be different to selectedSection (that had been pinned before)
            fetchThumbnailIndex(sliderData, selectedSection, selectedEntity, selectedPatient, "");
        } else {
            setPinSelectedSlide("checked");
            if (sliderData[highlightThumbnailIndex] !== undefined && 'title' in sliderData[highlightThumbnailIndex]) {
                setSelectedSection(sliderData[highlightThumbnailIndex]['title']);
            }
        }
    }

    function highlightSectionInSVG(selectedSection) {
        for (var i = 0; i < sliderData.length; i++) {
             const label = sliderData[i]['title'];
             let el = document.querySelector("#svg_" + label);
             if (el) {
                 if (label === selectedSection) {
                    el.style="opacity: 1; stroke-width: 5px; fill: rgb(219, 0, 0); stroke: rgb(219, 0, 0);"
                 } else {
                    el.style="opacity: 0.2; stroke-width: 0px; fill: rgb(155, 0, 0); stroke: rgb(219, 0, 0);"
                 }
             }
             el = document.querySelector("#svg_text_" + label);
             if (el) {
                 if (label === selectedSection) {
                    el.style="opacity: 1.0"
                 } else {
                    el.style="opacity: 0.0"
                 }
             }
        }
    }

    function handleSectionSelectionViaSVG(e) {
        const id = e.target.getAttribute("id");
        const section = id.replace("svg_","");
        fetchThumbnailIndex(sliderData, section, "", selectedPatient, pinSelectedSlide);
        setSelectedSection(section);
    }

    const onPopupScroll = (e) => {
       // DEBUG: console.log('onPopupScroll', e);
    };

    // Work out which column of the grid layout each dropdown goes in - depending on which data is available
    // Row 1 of dropdowns starts
    let colCnt = 1;
    let pCol;
    if (patients.length > 0) {
        pCol = "col" + colCnt++;
    }

    const featureTypeCol = "col" + colCnt++;
    const featureCol = "col" + colCnt++;
    const hierarchicalVarCol = "col" + colCnt++;
    colCnt = 1;
    const optionsDropdownCol = "col" + colCnt++;
    const filterFeatureByButtonCol = "col" + colCnt++;

    return (
        <div>
            <Watermark content={watermark}>
                { // Header
                }
                <div className="header-wrapper">
                    <div className="col1 logo">
                      <a href={labUrl}>
                          <img
                              alt=""
                              src={apiRootURI + "logo/" + project}
                              width="30"
                              height="30"
                          />
                      </a>
                     </div>
                     <div className="col2 project-label">
                        <div> &nbsp;WebAtlas 2.0 > {description}
                        <a href={infoUrl} className="project-description"><i class="bi bi-link-45deg"></i></a></div>
                     </div>
                     <div className="col3">
                        <Button className="button" href="https://haniffalab.com/webatlas-pipeline/" variant="outline-light">Docs</Button>{''}
                     </div>
                </div>

            <Container fluid="md" className="container-margin-bottom">
              <Row>
                {
                    // SVG, if available for the project
                }
                {
                    SVG !== '' ?
                        <Col xs={2} md={2}>
                              <div className={"svg-viewer"}>
                                  <SVG onClick={handleSectionSelectionViaSVG} />
                                      {sliderData ? sliderData.map((item, idx) => (
                                        <Tooltip id={"svg_" + item['title']} html={item['title']} />
                                      ))
                                      :""
                                      }
                              </div>
                        </Col>
                   :""
                }
                <Col xs={10} md={10}>

                    <div className="wrapper">
                      { // Patient selection part
                      }
                      {
                          patients.length > 0 ?
                              <div className={pCol}>
                                <Form.Group className="non-hierarchical-sel">
                                    <Form.Label htmlFor="patient_selection" className="sel_label">
                                        Section Groups <i class="bi bi-filter-circle"
                                            data-tooltip-id="patient_filter_tooltip"
                                            data-tooltip-content="Filter images by patient"
                                            data-tooltip-place="top"></i>
                                    </Form.Label>
                                    <Tooltip id="patient_filter_tooltip" />
                                    <Select selectedValue={selectedPatient}
                                        value={{ label: selectedPatient !== "" ? selectedPatient: "Select..."}}
                                        className="dropdown"
                                        id="patient_selection" options={patients} onChange={handlePatientSelectionEvent} />
                                </Form.Group>
                              </div>
                          : ""
                      }
                      { // Entity (Feature or Categorical Variable) type selection part
                      }
                      <div className={featureTypeCol}>
                        <Form.Group className="non-hierarchical-sel">
                            <Form.Label htmlFor="entity_type_selection" className="sel_label">
                                Entity Types <i class="bi bi-ui-radios"
                                data-tooltip-id="entity_type_selection_tooltip"
                                data-tooltip-content="Select type of feature or categorical variable to search and then highlight in the image"
                                data-tooltip-place="top"
                                id="feature_search"></i>
                            </Form.Label>
                            <Tooltip id="entity_type_selection_tooltip" />
                            <Select selectedValue={selectedEntityType  !== "" ? getDisplayName(selectedEntityType, true) :  "Genes"}
                            placeholder={selectedEntityType  !== "" ? getDisplayName(selectedEntityType, true) :  "Genes"}
                            className="dropdown"
                            id="entity_type_selection"
                            styles={{
                              groupHeading: (base) => ({
                                ...base,
                                flex: '1 1',
                                color: 'white',
                                margin: 0,
                              }),
                              // See: https://stackoverflow.com/questions/58801252/possible-to-change-font-color-on-react-select
                              placeholder:  (base) => ({
                                ...base,
                                color: 'black'
                              })
                            }}
                            components={{ GroupHeading }}
                            options={groupedOptions}
                            onChange={handleEntityTypeSelectionEvent} />
                        </Form.Group>
                     </div>
                      { // Feature selection part
                      }
                      <div className={featureCol}>
                        <Form.Group className="non-hierarchical-sel">
                            <Form.Label htmlFor="feature_selection" className="sel_label">
                                {getDisplayName(selectedEntityType, true)} <i class="bi bi-graph-up"
                                    data-tooltip-id="feature_sel_tooltip"
                                    data-tooltip-content="Highlight expression/abundance"
                                    data-tooltip-place="top"></i>
                            </Form.Label>
                            <Tooltip id="feature_sel_tooltip" />
                            <Select ref={featureRef}
                                className="dropdown"
                                value={{ label: selectedEntity !== "" && selectedEntity.split("@")[0] === selectedEntityType ? selectedEntity.split("@")[1]: "Select..."}}
                                selectedValue={selectedEntity !== "" && selectedEntity.split("@")[0] === selectedEntityType ? selectedEntity.split("@")[1]: ""}
                                id="feature_selection"
                                options={features}
                                onChange={(e) => handleEntitySelectionEvent(e, selectedEntityType) } />
                        </Form.Group>
                      </div>
                     { // Hierarchical (categorical) var selection part
                        // N.B. In options below:
                        // 1. placeholder="Select.." is omitted as it's overridden by value= assignment anyway
                        // 2. treeDefaultExpandAll is not used - although it does expand the whole tree, it gives
                        //    a weird effect when scrolling down that one of the values gets replicated and overwrites
                        //    all other options in the dropdown.
                        //
                      }
                      {
                         categoricalEntityValues.length > 0 ?
                              <div className={hierarchicalVarCol}>
                                <Form.Group className="hierarchical-sel">
                                    <Form.Label htmlFor="hierarchical_var_selection" >
                                        {getDisplayName(selectedCategoricalEntityType, true)} <i class="bi bi-pin-map"
                                        data-tooltip-id="hierarchical_var_sel_tooltip"
                                        data-tooltip-content="Highlight location"
                                        data-tooltip-place="top"></i>
                                    </Form.Label>
                                    <Tooltip id="hierarchical_var_sel_tooltip" />
                                    <TreeSelect
                                          id="hierarchical_var_selection"
                                          showSearch
                                          style={{
                                            width: '100%',
                                            marginTop: '-3px'
                                          }}
                                          dropdownStyle={{
                                            maxHeight: 400,
                                            overflow: 'auto',
                                          }}
                                          allowClear
                                          onChange={(e) => handleEntitySelectionEvent(e, selectedCategoricalEntityType) }
                                          treeData={categoricalEntityValues}
                                          onPopupScroll={onPopupScroll}
                                          value={selectedEntity !== "" && selectedEntity.split("@")[0] === selectedCategoricalEntityType ? selectedEntity.split("@")[1]: ""}
                                    />
                                </Form.Group>
                              </div>
                         : ""
                      }
                      </div>

                      <div className="wrapper1">
                      { // UI Options dropdown part
                        // className="options-accordion" - unused? in Accordion tag?
                      }
                      {
                          <div className={optionsDropdownCol}>
                                <Accordion >
                                  <Accordion.Item eventKey="0" >
                                    <Accordion.Header>UI Options</Accordion.Header>
                                    <Accordion.Body>
                                      { // Feature Intensity Colormap part
                                      }
                                      <div>
                                        <Form.Group>
                                            <Form.Label htmlFor="colormap_selection" className="sel-label">
                                                Feature Intensity Colourmap  <i class="bi bi-filter-circle"
                                                        data-tooltip-id="colormap_selection_tooltip"
                                                        data-tooltip-content="Select colour map for highlighting feature intensity"
                                                        data-tooltip-place="bottom"></i>
                                            </Form.Label>
                                            <Tooltip id="colormap_selection_tooltip" />
                                            <Select selectedValue={featureValueColormap}
                                                value={{ label: featureValueColormap}}
                                                className="dropdown"
                                                id="colormap_selection" options={featureIntensityColormaps} onChange={handleColormapSelectionEvent} />
                                        </Form.Group>
                                      </div>
                                      { // Feature Intensity Colormap Range - UMAP
                                      }
                                      {
                                        !twoVitessceInstances ?
                                             <div>
                                                <Form.Group className="range-slider-sel">
                                                    <Form.Label htmlFor="colormap_range_umap_selection" className="sel-label">
                                                        Feature Colourmap Range: UMAP <i class="bi bi-filter-circle"
                                                                data-tooltip-id="colormap_range_umap_selection_tooltip"
                                                                data-tooltip-html="Select colour map range for highlighting feature intensity in Scatterplot.
                                                                <br />
                                                                The minimum and maximum values indicate the percentage of intensities shown using the same
                                                                <br />
                                                                leftmost and rightmost colour on the colormap range respectively.
                                                                <br />
                                                                Adjusting the colormap range can be used to increase the contrast of the displayed intensities."
                                                                data-tooltip-place="top"></i>
                                                    </Form.Label>
                                                    <Tooltip id="colormap_range_umap_selection_tooltip" />
                                                    <CRangeSlider distance={0.1} step={0.01} min={0} max={1} value={featureValueColormapRangeUMAP} onChange={handleColormapRangeUMAPSelectionEvent}
                                                    />
                                                </Form.Group>
                                              </div>
                                          : ""
                                      }
                                      { // Feature Intensity Colormap Range - Spatial
                                      }
                                      {
                                         <div>
                                            <Form.Group className="range-slider-sel">
                                                <Form.Label htmlFor="colormap_range_spatial_selection" className="sel-label">
                                                    Feature Colourmap Range: Spatial <i class="bi bi-filter-circle"
                                                            data-tooltip-id="colormap_range_spatial_selection_tooltip"
                                                            data-tooltip-html="Select colour map range for highlighting feature intensity in Spatial and thumbnails.
                                                            <br />
                                                            The minimum and maximum values indicate the percentage of intensities shown using the same
                                                            <br />
                                                            leftmost and rightmost colour on the colormap range respectively.
                                                            <br />
                                                            Adjusting the colormap range can be used to increase the contrast of the displayed intensities."
                                                            data-tooltip-place="top"></i>
                                                </Form.Label>
                                                <Tooltip id="colormap_range_spatial_selection_tooltip" />
                                                <CRangeSlider distance={0.1} step={0.01} min={0} max={1} value={featureValueColormapRangeSpatial} onChange={handleColormapRangeSpatialSelectionEvent}
                                                />
                                            </Form.Group>
                                          </div>
                                      }
                                      {
                                        // UI Settings - Show/Hide layerController in Vitessce
                                      }
                                      {
                                          <div className="toggle-spatial-layers">
                                                <label htmlFor="toggle-spatial-layers_btn">
                                                    <Button
                                                            id="toggle-spatial-layers_btn"
                                                            onClick={() => {
                                                                handleHideSpatialLayers();
                                                            }}
                                                            variant="outline-light">
                                                            <i class={"bi bi-"+eyeIcon}></i>
                                                    </Button>{''}
                                                      &nbsp;
                                                      Toggle Spatial Layers
                                                      &nbsp;&nbsp;
                                                    <i class="bi bi-info-circle"
                                                        data-tooltip-id="toggle-spatial-layers_tooltip"
                                                        data-tooltip-place="top"
                                                    ></i>
                                                </label>
                                                <Tooltip id="toggle-spatial-layers_tooltip"
                                                         html="Toggle visibility of Spatial Layers section below." />
                                          </div>
                                      }
                                      {
                                        // UI Settings - 'Show/hide 3D image' button
                                      }
                                      {
                                          threeDZarrUrl !== "" ?
                                              <div className="show-3d-zarr">
                                                    <label htmlFor="display-3d-zarr-layers_btn">
                                                        <Button
                                                                id="display-3d-zarr-layers_btn"
                                                                onClick={() => {
                                                                    if (show3DImage) {
                                                                        setThreeDeyeIcon("eye-slash");
                                                                    } else {
                                                                        setThreeDeyeIcon("eye");
                                                                    }
                                                                    setShow3DImage(!show3DImage);
                                                                }}
                                                                variant="outline-light">
                                                                 <i class={"bi bi-"+threeDeyeIcon}></i>

                                                        </Button>{''}
                                                        &nbsp; Toggle 3D Image &nbsp;
                                                        <i class="bi bi-info-circle"
                                                            data-tooltip-id="display-3d-zarr-layers_tooltip"
                                                            data-tooltip-place="top"
                                                        ></i>
                                                    </label>
                                                    <Tooltip id="display-3d-zarr-layers_tooltip"
                                                             html="Show/hide synchrotron data in 3D" />
                                              </div>
                                          :   ""
                                      }
                                      {
                                        // Switch focus to the other spatial panel part
                                      }
                                      {
                                        twoVitessceInstances ?
                                            <div className="panel-focus-switch">
                                                <Form>
                                                  <Form.Check
                                                    type="switch"
                                                    id="spatial-panel-in-focus"
                                                    label="Spatial panels: switch focus"
                                                    onChange={handleSpatialPanelFocusSwitch}
                                                  />
                                                </Form>
                                                <i class="bi bi-info-circle panel-focus-switch-info"
                                                            data-tooltip-id="slider_legend_middle_tooltip"
                                                            data-tooltip-place="top"
                                                            ></i>
                                                <Tooltip id="slider_legend_middle_tooltip"
                                                         html="Bring into focus the left or right spatial panel below - so that you can select<br />(by clicking on a thumbnail at the bottom of the page) a section to be shown in it,<br />or to highlight your entity of interest in that panel only<br />(having also ticked the 'Highlight in spatial panel in-focus only' checkbox)." />
                                                <Tooltip id="highlight_in_selected_panel_only_tooltip"
                                                         html={"Highlight selected entity in the spatial panel in-focus only"} />
                                            </div>
                                            : ""
                                      }
                                      {
                                        // UI Settings - Pin selected (or both) slide(s)
                                      }
                                      {
                                          <div className={twoVitessceInstances ? "pin-selected-slide-checkbox-mv" : "pin-selected-slide-checkbox"}>
                                                <label htmlFor="pin_selected_slide_checkbox">
                                                  <input
                                                    type="checkbox" name="pin_selected_slide_checkbox"
                                                    onChange={handlePinSelectedSlideChange}
                                                    checked={pinSelectedSlide} />
                                                  &nbsp;&nbsp;
                                                  {twoVitessceInstances ? "Pin both slides" : "Pin selected slide"}
                                                  &nbsp;&nbsp;
                                                  <i class="bi bi-info-circle"
                                                                data-tooltip-id="pin_selected_slide_tooltip"
                                                                data-tooltip-place="top"
                                                            ></i>
                                                 </label>
                                                 <Tooltip id="pin_selected_slide_tooltip"
                                                         html={"Show an entity of interest within the pinned slide" + (twoVitessceInstances ? "s." : ".") + "<br />If no slide is pinned, the left-most slide is selected from the list sorted by the highest intensity of the searched entity first."} />

                                          </div>
                                      }
                                      {
                                        // UI Settings - highlightInPanelInFocusOnly selection - to enable showing two different entities in
                                        // the same (or different) spatial sections. This can be useful if the two entities are in some way
                                        // understood to be correlated (e.g. a gene on one side and a factor/gene program of which that gene is a member - on the other)
                                        // and the user wants to check if their spatial intensity confirms that correlation.
                                      }
                                      {
                                        twoVitessceInstances ?
                                          <div className="highlight-in-spatial-panel-in-focus-only">
                                                <label htmlFor="highlight_in_selected_panel_only_checkbox">
                                                  <input
                                                    type="checkbox" name="highlight_in_selected_panel_only_checkbox"
                                                    onChange={handleHighlightInPanelInFocusOnlyChange}
                                                    checked={highlightInPanelInFocusOnly} />
                                                  &nbsp;
                                                  Highlight in spatial panel in-focus only
                                                  &nbsp;&nbsp;
                                                  <i class="bi bi-info-circle"
                                                                data-tooltip-id="highlight_in_selected_panel_only_tooltip"
                                                                data-tooltip-place="top"
                                                            ></i>
                                                 </label>
                                          </div>
                                          : ""
                                      }
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                          </div>
                      }
                      { // Highlight feature with filter by hierarchical value button
                      }
                      {
                        filterFeature && filterCategoricalEntity ?
                              <div className={filterFeatureByButtonCol + " offcanvas-button"} >
                                 <Form.Group className="filter-by-button">
                                    <Form.Label htmlFor="filter_feature_by" className="sel_label">
                                        Highlight {filterFeature} in {filterCategoricalEntity} <i class="bi bi-graph-up"
                                            data-tooltip-id="filter_feature_by_tooltip"
                                            data-tooltip-content="Highlight (in a separate window) the selected feature in cells corresponding to the selected hierarchical entity"
                                            data-tooltip-place="top"></i>
                                            <i class="bi bi-pin-map"></i>
                                    </Form.Label>
                                    <Tooltip id="filter_feature_by_tooltip" />
                                    <Button
                                        id="filter_feature_by"
                                        onClick={() => {
                                            setShowOffCanvas(true);
                                        }}
                                        variant="outline-light">Show</Button>{''}
                                </Form.Group>

                                <Offcanvas
                                    show={showOffCanvas}
                                    onHide={handleOffCanvasClose}
                                    className="w-75"
                                >
                                    <Offcanvas.Header closeButton>
                                      <Offcanvas.Title>
                                            {filterFeature} intensity in {filterCategoricalEntity}
                                            <div className="offcanvas-title-note">Use your mouse to zoom in/out.</div>
                                      </Offcanvas.Title>
                                      <div className="slider-legend-filter offcanvas_img">
                                        <div>
                                            <img
                                              alt=""
                                              src={apiRootURI + "colour_legend/"+ project + "/" + selectedEntityType  + "/" + filterFeature.replaceAll("/"," and ") + "/" + featureValueColormap +
                                                "?feature_value_colormap_range="+featureValueColormapRangeSpatial[0] + "," + featureValueColormapRangeSpatial[1]}
                                              width="300"
                                              height="80"
                                            />
                                            <i class="bi bi-info-circle slider-legend-filter-info"
                                                data-tooltip-id="slider_legend_tooltip"
                                                data-tooltip-place="top"
                                            ></i>
                                        </div>
                                        <Tooltip id="slider_legend_tooltip"
                                                 html="A filter has been applied to hide feature expressions of low intensity, based on the intensity distribution in each section.<br />The colour range shown is between the minimum intensity cut-off and the highest intensity - across all sections." />
                                      </div>
                                    </Offcanvas.Header>
                                    <p/><p/><p/>
                                    <Offcanvas.Body>
                                      <div className="container-mode">
                                          <ImageViewer
                                            img={apiRootURI + "image/" + project + "/" +
                                                                  (highlightThumbnailIndex > dontRerenderIdx ? sliderData[highlightThumbnailIndex]['img_name'] : sliderData[0]['img_name']) +
                                                                  "?entityType="+selectedEntityType+
                                                                  "&entity="+filterFeature+
                                                                  "&filterCategoricalEntityType="+selectedCategoricalEntityType+
                                                                  "&filterCategoricalEntity="+filterCategoricalEntity+
                                                                  "&full_size=true&feature_value_colormap="+featureValueColormap+"&feature_value_colormap_range="+featureValueColormapRangeSpatial}
                                            hiResImg={apiRootURI + "image/" + project + "/" +
                                                                  (highlightThumbnailIndex > dontRerenderIdx ? sliderData[highlightThumbnailIndex]['img_name'] : sliderData[0]['img_name']) +
                                                                  "?entityType="+selectedEntityType+
                                                                  "&entity="+filterFeature+
                                                                  "&filterCategoricalEntityType="+selectedCategoricalEntityType+
                                                                  "&filterCategoricalEntity="+filterCategoricalEntity+
                                                                  "&full_size=true&feature_value_colormap="+featureValueColormap+"&feature_value_colormap_range="+featureValueColormapRangeSpatial}
                                            width={"1200px"}
                                            height={"1200px"}
                                            style={{ background: "white" }}
                                            zoomStep={50} // default is 50
                                            defaultZoom={100} //default is 100
                                            maxZoom={500} //default is 500
                                            snapView={true} //default is true
                                            refreshOnResize={true} //default is true
                                            zoomOnMouseWheel={true} //default is true
                                            hasZoomButtons={true} //default is true
                                          />
                                      </div>

                                    </Offcanvas.Body>
                                </Offcanvas>

                              </div>
                        : ""
                      }
                      {
                      }

                     </div>
                </Col>

              </Row>
            </Container>

                { // 3D viewer part
                }
                {
                    <div
                      className={ "itk-vtk-viewer itk-vtk-local" + (!show3DImage ? " div_hidden" : "")}
                      data-url={threeDZarrUrl}
                      data-viewport="750x500"
                      data-background-color="3f3f42"
                    ></div>
                }
                { // Vitessce part
                    !show3DImage ?
                        <div className={ twoVitessceInstances ? "vitessce-grid" : "no-vitessce-grid"}>
                                <div style={{ height: twoVitessceInstances ? "545px" : "600px" }} className={(twoVitessceInstances ? "multi-vitessce " : "single-vitessce ") +
                                        "col1 " + (twoVitessceInstances && !rightSpatialPanelInFocus ? "vitessce-in-focus" : "")}>
                                    <Vitessce config={selectedConfig} onConfigChange={onConfigChangeCallback} height={600} width={200} theme="dark" />
                                </div>
                            { twoVitessceInstances ?
                                <div style={{ height: twoVitessceInstances ? "545px" : "600px" }} className={"multi-vitessce col2 " + (rightSpatialPanelInFocus ? "vitessce-in-focus" : "")}>
                                    <Vitessce config={selectedConfig1} onConfigChange={onConfigChangeCallback1} height={600} width={200} theme="dark" />
                                </div>
                              : ""
                            }
                        </div>
                    :   ""
                }
                { // Slider legend part
                }
                {
                    !show3DImage ?
                        selectedEntity !== "" && selectedEntity.split("@")[0] === selectedEntityType ?
                        <div className="slider-legend-wrapper">
                            {
                            RNASeqPlotData.length > 0 ?
                            <div className="col1 thumbnails-legend-plot">
                                <MantineProvider theme={theme}>
                                    <Title align="center" size={13} weight={20} color="dimmed" className="rnaseq-plot-title">
                                        {selectedEntity.split("@")[1] + ": mean snRNASeq expr. in " + RNASeqPlotTitle}

                                        <i class="bi bi-info-circle max-intensity-plot-filter-info"
                                            data-tooltip-id="bubble_plot_tooltip"
                                            data-tooltip-place="bottom"
                                        ></i>
                                    </Title>
                                    <BubbleChart
                                      h={60}
                                      w={400}
                                      data={RNASeqPlotData}
                                      range={[Math.min(...RNASeqPlotData.map(o => o.expression))*100, Math.max(...RNASeqPlotData.map(o => o.expression))*800]}
                                      label=""
                                      color="lime.6"
                                      dataKey={{ x: 'annotation', y: 'index', z: 'expression' }}
                                      xAxisProps={{
                                                angle: -90,
                                                tickMargin: 52
                                           }}
                                      tooltipAnimationDuration={200}
                                      style={{
                                             color: '#000000'
                                      }}
                                      valueFormatter={(value) => `mean expr. : ${value}`}
                                    />
                               </MantineProvider>
                            </div>
                            : ""
                            }
                            <div className="col2 thumbnails-legend-plot">
                                <MantineProvider>
                                    <Title align="center" size={13} weight={20} color="dimmed">
                                        {selectedEntity.split("@")[1] + ": max. and mean filtered intensities per section"}
                                        <i class="bi bi-info-circle max_intensity_plot_filter_info"
                                            data-tooltip-id="max_intensity_plot_tooltip"
                                            data-tooltip-place="bottom"
                                        ></i>
                                    </Title>
                                    <AreaChart
                                          // See:  https://mantine.dev/charts/area-chart/
                                          // style={{
                                          //   backgroundColor: '#8d8d8d',
                                          //   color: '#ffffff',
                                          // }}
                                          h={80}
                                          data={intensityPlotData}
                                          dataKey="Section"
                                          // yAxisLabel={selectedEntity.split("@")[1] + ": max. intensity"}
                                          series={[
                                            { name: 'Max. intensity', color: '#1c8c74' },
                                            { name: 'Avg. intensity', color: '#eb821a' }
                                          ]}
                                          curveType="monotone"
                                          dotProps={{ r: 2, strokeWidth: 1 }}
                                          activeDotProps={{ r: 4, strokeWidth: 1 }}
                                          withXAxis={false}
                                          // withPointLabels
                                          tooltipAnimationDuration={200}
                                          gridAxis="none"
                                    />
                                </MantineProvider>
                            </div>

                            <div className="col3 thumbnails-legend-plot">
                                <MantineProvider theme={theme}>
                                    <Title align="center" size={13} weight={20} color="dimmed">
                                        {"Top " + numTopFeatures + " " + selectedEntityType + "s by max. intensity in selected section"}
                                    </Title>
                                    <BarChart
                                          // See:  https://mantine.dev/charts/bar-chart/
                                          h={80}
                                          w={320}
                                          data={topFeaturesPlotData}
                                          dataKey="Feature"
                                          series={[
                                            { name: 'Max. intensity', color: '#1c8c74' },
                                          ]}
                                          gridAxis="none"
                                          tooltipAnimationDuration={200}
                                          // xAxisProps={{
                                          //      angle: -45,
                                          //      tickMargin: 15
                                          // }}
                                    />
                                </MantineProvider>
                            </div>
                            {
                            twoVitessceInstances ?
                                <div className="col3 thumbnails-legend-plot_two_vitessce">
                                    <MantineProvider theme={theme}>
                                        <Title align="center" size={13} weight={20} color="dimmed">
                                            {"Top " + numTopFeatures + " " + selectedEntityType + "s by max. intensity in the other section"}
                                        </Title>
                                        <BarChart
                                              // See:  https://mantine.dev/charts/bar-chart/
                                              h={80}
                                              w={320}
                                              data={otherTopFeaturesPlotData}
                                              dataKey="Feature"
                                              series={[
                                                { name: 'Max. intensity', color: '#1c8c74' },
                                              ]}
                                              gridAxis="none"
                                              tooltipAnimationDuration={200}
                                              // xAxisProps={{
                                              //      angle: -45,
                                              //      tickMargin: 15
                                              // }}
                                        />
                                    </MantineProvider>
                                </div>
                            : ""
                            }
                        </div>
                        : ""
                    :""
                }
                {
                    !show3DImage ?
                        selectedEntity !== "" && selectedEntity.split("@")[0] === selectedEntityType ?
                        <div className={ twoVitessceInstances ? "slider-legend-two_vitessce": "slider-legend-right"}>
                            <div>
                                    <img
                                          alt=""
                                          src={apiRootURI + "colour_legend/"+ project + "/" + selectedEntity.split("@")[0]  + "/" + selectedEntity.split("@")[1].replaceAll("/"," and ") + "/" + featureValueColormap +
                                               "?feature_value_colormap_range="+featureValueColormapRangeSpatial[0] + "," + featureValueColormapRangeSpatial[1]}
                                          width="240"
                                          height="64"
                                    />
                                    <i class="bi bi-info-circle slider_legend_filter_info"
                                        data-tooltip-id="slider_legend_tooltip"
                                        data-tooltip-place="top"
                                        ></i>
                            </div>
                            <Tooltip id="slider_legend_tooltip"
                                     html="A filter has been applied to hide feature expressions of low intensity, based on the intensity distribution in each section.<br />The colour range shown is between the minimum intensity cut-off and the highest intensity - across all sections. " />
                            <Tooltip id="max_intensity_plot_tooltip"
                                     html="Sections have been sorted by the highest max. intensity of the selected feature first. In a given section:<br />1. the max. intensity of 0 indicates that the selected feature is not expressed in this section at all;<br />2. the max. intensity equal to the minimum intensity cut-off across all sections (see the left-hand side of the legend)<br />indicates that all expressions of the feature in this section are below the cut-off. " />
                            <Tooltip id="bubble_plot_tooltip"
                                     html={"The plot shows mean (min-max normalised) snRNASeq expression of the selected feature<br>within each of " + RNASeqPlotTitle + "."} />
                        </div>
                        : ""
                    : ""
                }
                { // Slider part
                }
                {
                !show3DImage ?
                    <div className={twoVitessceInstances ? "slider-two-vitessce" :
                                    (selectedEntity !== "" && selectedEntity.split("@")[0] === selectedEntityType) || !hideSpatialLayers ? "slider" : "slider_no_entity" }>
                      <div>
                        <Slider {...settings} ref={(slider) => setSlider(slider)}>
                          {sliderData.map((item, idx) => (
                            <div id={item.tag_id}
                                key={item.id}
                                className={selectedSlide === idx ? "active": null}
                                onClick={() => {
                                    // setSelectedSlide(idx);
                                    if (item.title)
                                    // Note: item.title is blank only for 'blank' slides (see note in fetchSliderData()) -
                                    // we don't allow the user to click on them (as there's nothing to see!)
                                    {
                                        setHighlightThumbnailIndex(idx);
                                        fetchConfig(project, item.img_name, selectedEntity, hideSpatialLayers, rightSpatialPanelInFocus);
                                        // selectedSection is used to find the index of that section
                                        // in case selectedEntity had been selected (in which case
                                        // the order of thumbnails is highest expression first (i.e. not
                                        // the default one in section_annotations.tsv)
                                        const title = sliderData[idx]['title'];
                                        highlightSectionInSVG(title);
                                        setSelectedSection(title);
                                    }
                                }}>
                              <div className="img-body">
                                <img src={item.src} alt={item.alt} />
                              </div>
                              <div className="slider-section-title">
                                {item.title}
                                <br />{item.description}
                              </div>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    </div>
                : ""
                }
            </Watermark>
        </div>
      );
}

